// @flow

import { urlOf } from '../util/api';
import PaymentLinkData from './PaymentLinkData';

class PaymentData {
  callbackUrl: string;
  scripts: Array<string>;
  error: string;
  linkData: ?PaymentLinkData;

  copyFrom(raw: any) {
    this.callbackUrl = urlOf(raw.callbackUrl);
    this.scripts = raw.scripts || [];
    this.linkData = raw.linkData;
    this.error = raw.error;
  }
}

export default PaymentData;
